module.exports = __webpack_public_path__ + "static/media/cw.6c845a30.svg";